module.exports = __webpack_public_path__ + "img/rightthigh-endo-mesomorph-male.90080c10.svg";